"use client";

import { ArrowRight, Mail } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const contactChannels = [{
  icon: Mail,
  label: "EMAIL",
  value: "support@benewealth.info",
  href: "mailto:support@benewealth.info"
}];
export default function PartnerInquiry() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="2849" id="partner-inquiry" className="bg-background text-foreground py-24 md:py-40 px-6 md:px-12 lg:px-20">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24">
          <div ref={leftRef} className={`transition-all duration-1000 ease-out ${leftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <p className="font-default text-[0.875rem] tracking-[0.15em] uppercase text-primary mb-10">
              Architect of Capital
            </p>

            <h2 className="font-default text-5xl md:text-6xl lg:text-7xl leading-[1.1] text-foreground mb-10 font-bold">
              Let’s build your{" "}
              <span className="italic text-primary font-light">next deal</span>.
            </h2>

            <p className="font-default text-lg md:text-xl text-muted-foreground leading-relaxed mb-16 max-w-lg">
              BeneWealth Financial provides the infrastructure for real estate investors to scale. Whether you need first mortgage debt or gap equity, our engines are designed to close the gap between opportunity and execution.
            </p>

            <div className="border-t border-border">
              {contactChannels.map((channel, i) => {
              const Icon = channel.icon;
              return <div key={channel.label} data-index={i} className="border-b border-border py-6 flex items-start gap-5 group">
                    <Icon strokeWidth={1} className="size-5 text-primary mt-1 shrink-0" />
                    <div className="flex-1">
                      <p className="font-default text-[0.75rem] tracking-[0.15em] uppercase text-muted-foreground mb-2">
                        {channel.label}
                      </p>
                      <Link to={channel.href} className="font-default text-xl text-foreground hover:text-primary transition-colors">
                        {channel.value}
                      </Link>
                    </div>
                  </div>;
            })}
            </div>
          </div>

          <div ref={rightRef} className={`transition-all duration-1000 ease-out delay-150 flex flex-col justify-center ${rightVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="space-y-8">
              <p className="font-default text-xl md:text-2xl text-muted-foreground leading-relaxed tracking-wide">
                Ready to deploy institutional capital into your next project? Our streamlined qualification process ensures we move at the speed of your deal.
              </p>
              
              <div className="pt-4">
                <Link to="/PreQualificationFormPage">
                  <Button size="lg" className="w-full md:w-auto h-16 px-10 bg-primary text-primary-foreground hover:bg-primary/90 font-default text-sm tracking-[0.25em] uppercase font-bold group rounded-lg">
                    <span>Get Pre-Qualified</span>
                    <ArrowRight className="size-5 ml-3 transition-transform group-hover:translate-x-1" />
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}